@if (showRibbon) {
<div [ngClass]="['corner-ribbon', position, 'sticky', color, 'shadow']">{{ tag }}</div>
}
